/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three numbers per row: the x position, the y position and the size of the bubble. Each row becomes one sized circle.`)
};

const es_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres números por fila: la posición x, la posición y y el tamaño de la burbuja. Cada fila se convierte en un círculo dimensionado.`)
};

const de_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei Zahlen pro Zeile: die x-Position, die y-Position und die Größe der Blase. Jede Zeile wird zu einem bemessenen Kreis.`)
};

const nl_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie getallen per rij: de x-positie, de y-positie en de grootte van de bel. Elke rij wordt één gedimensioneerde cirkel.`)
};

const fr_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois nombres par ligne : la position x, la position y et la taille de la bulle. Chaque ligne devient un cercle dimensionné.`)
};

const it_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre numeri per riga: la posizione x, la posizione y e la dimensione della bolla. Ogni riga diventa un cerchio dimensionato.`)
};

const pt_br2_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três números por linha: a posição x, a posição y e o tamanho da bolha. Cada linha se torna um círculo dimensionado.`)
};

const pt_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três números por linha: a posição x, a posição y e o tamanho da bolha. Cada linha torna-se um círculo dimensionado.`)
};

const ja_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行につき3つの数値: x位置、y位置、バブルのサイズです。各行が1つのサイズ付き円になります。`)
};

const zh_bubble_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行三个数字：x 位置、y 位置和气泡的大小。每行成为一个带大小的圆。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_faq_a1", locale)
	if (locale === "en") return en_bubble_faq_a1(inputs)
	if (locale === "es") return es_bubble_faq_a1(inputs)
	if (locale === "de") return de_bubble_faq_a1(inputs)
	if (locale === "nl") return nl_bubble_faq_a1(inputs)
	if (locale === "fr") return fr_bubble_faq_a1(inputs)
	if (locale === "it") return it_bubble_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_faq_a1(inputs)
	if (locale === "pt") return pt_bubble_faq_a1(inputs)
	if (locale === "ja") return ja_bubble_faq_a1(inputs)
	return zh_bubble_faq_a1(inputs)
};